import Vue from 'vue'
import { createPinia, PiniaVuePlugin, setActivePinia } from 'pinia'

Vue.use(PiniaVuePlugin)

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default (context, inject) => {
  const pinia = createPinia()
  setActivePinia(pinia)
  context.app.pinia = pinia
  context.pinia = pinia
  inject('pinia', pinia)
}
